import { useQuery } from "@tanstack/react-query";
import {
  getFidelizationConfigSummary,
  getMigrationConfigSummary,
} from "@/shared/actions/campanas/migracion.actions";

type CampaignType = "" | "MIGRATION" | "FIDELIZATION";

export const useCampaignConfigSummary = (campaignType: CampaignType) => {
  const query = useQuery({
    queryKey: ["campaign-config-summary", campaignType],
    queryFn: async () => {
      try {
        if (campaignType === "MIGRATION") {
          return await getMigrationConfigSummary();
        }

        return await getFidelizationConfigSummary();
      } catch {
        return null;
      }
    },
    enabled: !!campaignType,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    data: query.data?.data ?? query.data ?? null,
    loading: query.isLoading,
    error: query.isError,
  };
};